import { iSupplierPaymentMethod } from "@sdk/supplier-payment-methods/supplier-payment-method-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectSupplierPaymentMethodQueryMap,
  selectEntityMap: selectSupplierPaymentMethodsMap,
  selectQueryMapAll: selectSupplierPaymentMethodsMapAll,
  selectQueryAllList: selectSupplierPaymentMethodsAllList,
  selectAllEntities: selectAllSupplierPaymentMethods,
  selectAllEntitiesQuery: selectAllSupplierPaymentMethodsQuery,
  selectEntityById: selectSupplierPaymentMethodById,
  selectEntityQuery: selectSupplierPaymentMethodQuery,
  selectEntityQueryList: selectSupplierPaymentMethodQueryList,
} = CreateSelectorForEntities<iStore, iSupplierPaymentMethod>({
  sliceName: "supplierPaymentMethods",
});
